export default __webpack_public_path__ + "static/185-2ce38be48c7704c07d3f4357d28a5e91.jpg";